import axios from "axios"
import { sendSocket } from '@/timer/socket.js';

// element Ui
import {
	// ElMessage,
	ElNotification,
	ElMessageBox,
	ElLoading 
} from 'element-plus'

// 路由
import router from '@/router'

// vuex 数据
import store from '@/store'

//	工具库
export const util = {
	
	//	配置参数
	config: {
		apiHost:'https://api.qingsuiwang.com',
		fileHost:'https://api.qingsuiwang.com/shop/images/',

		prefix:'qsw_set_',
		
		// 高德地图
		mapKey: '1683e3941ae97d0310d6875da0f0fac4',
		mapCode: "d316bd6f07641ad6a58e2d4ccbfc64c4",
	},

	url(path){
		router.push({
			path: path
		})
	},

	parseFloatTwo(sum = 0){
		
		sum = sum ? sum : 0 ;

		// 保留两位小数，舍去不进位
		return Math.floor(sum * 100) / 100;
	},

	parseFloat(val,cou = 2){
		val = val ? val : 0;
		return parseFloat(parseFloat(val).toFixed(cou));
	},

	isRank(keys){
		var rankBut = store.state.rankBut;
		// console.log('typeof rankBut[keys]',typeof rankBut[keys])
        var off = false
        if(keys.length > 0){
            if(typeof rankBut[keys] !== 'undefined'){
                off = true
            }else{
              off = false
            }
        }else{
          off = false
        }

		return off;
	},

	jsonObj(data){
		return JSON.parse(JSON.stringify(data))
	},

	loginIs(fun = '',load = false){
		var that = this;

		var token = store.state.token;
		if(!token){
			that.getLogin();
		}

		var timesD = that.getTimes();
		var timesJ = store.state.user_times;

		if(token && timesD - timesJ <= 43200 && !load){
			fun ? fun(true) : '' ;
		}else{
			token = that.localGet('token')
			if(token){

				that.requestSync('/staff/user/userInfo',(data) => {
					if(data.code == 200){
						util.setLogin(data.data)

						fun ? fun(true) : '' ;
					}else{
						fun ? fun(false) : '' ;
					}
				});

			}else{
				fun ? fun(false) : '' ;
			}
		}

	},

	setLogin(user,way = true){
		if(way){
			store.state.user = user
			util.localSet('user',store.state.user)

			store.state.user_times = util.getTimes();
			util.localSet('user_times',store.state.user_times)

			this.setSendSocket(true);

		}else{
			store.state.user = 0
			util.localSet('user',store.state.user)
			store.state.token = 0
			util.localSet('token',store.state.token)

			store.state.user_times = 0
			util.localSet('user_times',0)

		}
	},

	getLogin(){
		store.state.user = util.localGet('user')
		store.state.token = util.localGet('token')
		this.setSendSocket(true);
	},

	loginUrl(way = false){

		alert('loginUrl');

		if(store.state.user != 0 && store.state.token != 0){
			if(store.state.port == 1){
				if(way){
					return '/admin/index/index';
				}else{
					router.push({
						path: '/admin/index/index'
					})
				}
			}else if(store.state.port == 2){
				if(way){
					return '/agency/index/index';
				}else{
					router.push({
						path: '/agency/index/index'
					})
				}
			}else if(store.state.port == 3){
				if(way){
					return '/area/index/index';
				}else{
					router.push({
						path: '/area/index/index'
					})
				}
			}else if(store.state.port == 4){
				if(way){
					return '/granary/index/index';
				}else{
					router.push({
						path: '/granary/index/index'
					})
				}
			}else if(store.state.port == 5){
				if(way){
					return '/supply/index/index';
				}else{
					router.push({
						path: '/supply/index/index'
					})
				}
			}
		}
	},

	logout(){
		util.setLogin({},false);
		router.push({
			path: '/login'
		})
	},

	//	加载效果
	showLoading() {
		ElLoading.service({
			background: "rgba(0,0,0,.3)",
			text: "加载中...",
		})
	},

	//	关闭加载效果
	hideLoading() {
		ElLoading.service({}).close();
	},

	//	弹窗
	alert(obj,types = 'success') {
		//	这个地方说白了就是 如果只是想提示一句话一个文本的话 就只是弹个小tips
		if (typeof obj == "string" || typeof obj == "number") {
			// ElMessage({
			// 	message: obj,
			// 	type: types, // error
			// 	duration: 2000,
			// 	showClose: false,
			// })

			ElNotification({
				title: '系统提示',
				message: obj,
				duration: 2000,
				position:'bottom-right',
				type: types,
			})

			return
		}

		//	标题
		obj.title = obj.title ? obj.title : ""
		//	提示内容
		obj.value = obj.value ? obj.value : "提示信息"
		//	确定文本
		obj.confirmText = obj.confirmText ? obj.confirmText : "确定"
		//	取消按钮
		obj.cancel = obj.cancel === false ? false : true
		obj.modal = obj.modal === true ? true : false
		//	取消文本
		obj.cancelText = obj.cancelText ? obj.cancelText : "取消"

		obj.type = obj.type ? obj.type : 'warning'
		// 'warning'
		// 'error'
		// 'success'
		
		// 返回Promise对象
		ElMessageBox.alert(obj.value,obj.title,{
			confirmButtonText: obj.confirmText,
			cancelButtonText: obj.cancelText,
			showCancelButton:obj.cancel,

			closeOnClickModal: obj.modal,
			closeOnPressEscape: obj.modal,

			dangerouslyUseHTMLString: true,
			draggable: true,
			center: true,
			showClose: false,
			type: obj.type,
		})
		.then(() => {
			if (typeof obj.success != 'undefined') {
				obj.success();
			}
		})
		.catch(() => {
			if (typeof obj.fail != 'undefined') {
				obj.fail();
			}
		})
	},

	prompt(obj){

		obj.title = obj.title ? obj.title : ""
		//	提示内容
		obj.value = obj.value ? obj.value : "提示信息"
		//	确定文本
		obj.confirmText = obj.confirmText ? obj.confirmText : "确定"
		//	取消文本
		obj.cancelText = obj.cancelText ? obj.cancelText : "取消"

		obj.type = obj.type ? obj.type : 'success'

		ElMessageBox.prompt(obj.value, obj.title, {
			confirmButtonText: obj.confirmText,
			cancelButtonText: obj.cancelText,
		})
		.then(({ value }) => {
			if (typeof obj.success !== 'undefined') {
				obj.success(value);
			}
		})
		.catch(() => {
			if (typeof obj.fail !== 'undefined') {
				obj.fail();
			}
		})
	},

	requestSync(url,func = '') {
		url = util.config.apiHost + (url ? url : '')
		const xhr = new XMLHttpRequest();
		xhr.open('POST', url, false); // 第三个参数为 false 表示同步模式
		xhr.setRequestHeader('Authorization', 'Bearer ' + store.state.token);
		xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
		xhr.setRequestHeader('Content-Type', 'application/json');
		xhr.setRequestHeader('Accept', 'application/json'); // 告诉服务器返回 JSON 数据
		xhr.send(null);

		var msg = '';
		if (xhr.status === 200) {
			msg = JSON.parse(xhr.responseText);
		} else {
			msg = {code:300,msg:'登录错误'};
		}

		func ? func(msg) : ''
	},

	//	发送网络请求
	request(params) {
		//	返回方法
		return new Promise((resolve, reject) => {
			//	请求地址
			params.url = util.config.apiHost + (params.url ? params.url : '')

			// 判断是否加载
			// var loadId = 0;

			if (typeof params.load === 'undefined') {
				params.load = true;
			}

			if (params.load) {
				if(store.state.requestCou <= 0){
					if(store.state.requestCou < 0){
						store.state.requestCou = 0;
					}
					store.state.requestCou += 1;
					
					util.showLoading()
					// loadId = setTimeout(function(){
					// 	util.showLoading()
					// },100)
				}
			}

			//	请求方式
			params.method = params.method ? params.method : "POST"

			if(!params.data){
				params.data = {};
			}

			//	定义头部
			params.headers = {
				'Authorization': 'Bearer '+store.state.token,  // 看到这个token了没有，它在在第一步的第三行出现过~

				...params.headers,
			}

			params.data = params.data ? params.data : {};
			//	发送数据
			if (params.method == "POST") {
				if (!params.headers) {
					params.data = params.data ? JSON.stringify(params.data) : ""
				}
			} else {
				//	设置get传参
				params.params = params.data
				//	移除post类型下的data 改用params
				delete(params.data);
			}

			//	定义数据

			//	数据类型
			params.dataType = "json"

			// 发起网络请求
			axios(params)
			.then(res => {

				// if(loadId){
				// 	clearInterval(loadId)
				// }

				//
				if (params.load) {
					store.state.requestCou -= 1;
					if(store.state.requestCou <= 0){
						store.state.requestCou  = 0;
						util.hideLoading()
					}
				}

				// 如果
				if (
					res.data.code >= 400 && res.data.code <= 500
					|| res.code == 0
				) {

					if(res.data.code == 444){

						util.alert({
							type:'error',
							cancel:false,
							value:'您的登录状态已丢失，请重新登录',
							success:() => {
								util.logout();
							}
						});

					}else{
						if(res.code == 0){
							// 登出
							util.alert({
								type:'error',
								cancel:false,
								value:'系统错误',
							});
						}else{
							// 登出
							util.alert({
								type:'error',
								cancel:false,
								value:'暂无权限',
							});
							return
						}
					}
					
				}

				//	帮助突破技术瓶颈，提升思维能力
				params.success ? params.success(res.data) : () => {}

				resolve(res.data)
			})
			.catch(err => {
				//
				if (params.load) {
					util.hideLoading()
				}

				params.fail ? params.fail(err) : () => {}

				if(err.code == "ERR_BAD_RESPONSE"){
					// 登出
					util.alert({
						type:'error',
						cancel:false,
						value:'系统错误',
					});
					return
				}


				// 失败
				reject(err)
			})
		})
	},

	getFloat(num,fxd = 2){
		return parseFloat(num).toFixed(fxd);
	},

	// 对二补齐
	toTwo(str) {
		// 格式化字符
		let num = String(Number(str));

		// 判断时间
		if (num.length < 2) {
			num = '0' + num;
		}

		// 返回时间
		return num;
	},

	// 获取时间戳，返回秒级时间戳
	getTimes(times = '') {

		// 未传入或传入空值 -> 返回当前时间（秒）
		if (typeof times === 'undefined' || times === '' || times === null) {
			return Math.floor(Date.now() / 1000)
		}

		// Date 对象
		if (times instanceof Date) {
			return Math.floor(times.getTime() / 1000)
		}

		// 数字（可能为秒或毫秒）
		if (typeof times === 'number') {
			const s = String(times)
			if (s.length <= 10) {
				return parseInt(times)
			}
			return Math.floor(times / 1000)
		}

		// 字符串
		if (typeof times === 'string') {
			const s = times.trim()
			// 纯数字字符串
			if (/^\d+$/.test(s)) {
				return s.length <= 10 ? parseInt(s) : Math.floor(Number(s) / 1000)
			}

			// 兼容不同浏览器的日期解析，优先将 '-' 替换为 '/'
			const parsed = new Date(s.replace(/-/g, '/'))
			if (!isNaN(parsed.valueOf())) {
				return Math.floor(parsed.valueOf() / 1000)
			}

			// 兜底尝试
			const parsed2 = Date.parse(s)
			if (!isNaN(parsed2)) {
				return Math.floor(parsed2 / 1000)
			}

			// 无法解析
			return 0
		}

		// 其他类型不支持，返回0
		return 0

	},

	getBatch(){
		var y = parseInt(util.getDate('yyyy'));
		var m = util.getDate('MM');

		const date = new Date();
		const year = date.getFullYear();
		const month = date.getMonth() + 1; // 月份从0开始计算，需要加1
		var lastDay = new Date(year, month, 0).getDate();

		lastDay = parseInt(lastDay);
		lastDay = lastDay > 9 ? lastDay : '0'+lastDay;

		var batch = [y+'-'+m+'-01',y+'-'+m+'-'+lastDay];
		return batch;
	},

	/**
	 * 时间戳处理成时间
	 * @param {String} str 规则如下
	 * 时间格式		月、日、时、分、秒 单个字母不补0
	 * yyyy	年
	 * MM	月
	 * dd	日
	 * WW	周
	 * HH	小时	24小时制
	 * hh	小时	12小时制
	 * mm	分钟
	 * ss	秒
	 * a	am/pm
	 * 比如 'yyyy-MM-dd HH:mm:ss 周w a' 返回2023-02-06 11:19:19 周一 pm
	 * @param {Number} timestamp 需要处理的时间戳
	 * @return {String} 日期字符串
	 */
	getDate(str, timestamp) {
		// 当前时间
		const nowDate = new Date()
		// 周列表	歪果仁把周日放在第一位
		let weekList = ['日', '一', '二', '三', '四', '五', '六']

		// 格式化字符串
		if (!str || typeof str != 'string') {
			str = 'yyyy-MM-dd HH:mm:ss'
		}

		// 格式化时间戳
		if (!timestamp) {
			if(timestamp === 0){
				return ''
			}else{
				timestamp = nowDate.valueOf()
			}
		} else if (String(timestamp).length <= 10) {
			timestamp = timestamp * 1000
		}

		// 时间
		const date = new Date(timestamp)

		// 获取对应时间
		let year = date.getFullYear(),
			moth = date.getMonth() + 1,
			day = date.getDate(),
			week = date.getDay(),
			hour = date.getHours(),
			minute = date.getMinutes(),
			second = date.getSeconds()

		// 处理年
		str = str.replace('yyyy', year)
		// 处理月份
		str = str.replace('MM', this.toTwo(moth))
		str = str.replace('M', moth)
		// 处理日
		str = str.replace('dd', this.toTwo(day))
		str = str.replace('d', day)
		// 处理周
		str = str.replace('w', weekList[week])
		// 处理小时
		if (str.match('h')) {
			// 12小时制
			hour = hour > 12 ? hour - 12 : hour
			// 12小时制
			str = str.replace('hh', this.toTwo(hour))
			str = str.replace('h', hour)
		} else if (str.match('H')) {
			// 24小时制
			str = str.replace('HH', this.toTwo(hour))
			str = str.replace('H', hour)
		}
		// 处理分钟
		str = str.replace('mm', this.toTwo(minute))
		str = str.replace('m', minute)
		// 处理秒
		str = str.replace('ss', this.toTwo(second))
		str = str.replace('s', second)
		// 处理是上午还是下午
		let a = hour > 12 ? 'am' : 'pm'
		str = str.replace('a', a)
		return str
	},

	localGet(str = ''){
		var dataJson = localStorage.getItem(this.config.prefix + str);
        if(dataJson && dataJson != 'undefined' && dataJson != 'null'){
            return JSON.parse(dataJson);
        }else{
            return false;
		}
	},

	localSet(str = '',data = ''){
		localStorage.setItem(this.config.prefix + str,JSON.stringify(data));
	},

	load_times_if(str){

		if(store.state.load_times){
			var load_times = store.state.load_times[str];
			if(load_times != 'undefined' && load_times){
				// 判断服务器中的版本号
				console.log(str+'_load_times',load_times)

				// 缓存数据中的版本号
				var log_times = util.localGet(str);
				if(!log_times || load_times != log_times){
					util.localSet(str,load_times);
					return false;
				}else{
					return true;
				}

			}else{
				// 没有版本号
				return false;
			}
		}else{
			// 没有版本号
			return false;
		}

	},

	loads(fun = '',log = []){
		var that = this;
		fun ? fun() : '';

		var load_times_up = parseInt(that.localGet('load_times_up'));
		var times = that.getTimes();

		if(!store.state.system || times - load_times_up > 120){
			that.localSet('load_times_up',times);
			that.request({
				url:'/api/system/defaults',
				load:false,
				data:{},
				success(e){

                    var configs = e.data.config

					store.commit('setState', {
						key: 'system',
						value: configs
					})

                    that.localSet('load_times_up',configs);

					for(var k in log){
						if(!that.load_times_if(log[k]+'_times')){
							fun ? fun() : '';
							return false;
						}
					}
				},
				fail(e){
                    console.log(e)
				}
			})
		}else{
            for(var k in log){
                if(!that.load_times_if(log[k]+'_times')){
                    fun ? fun() : '';
                    return false;
                }
            }
        }

	},

	get_type(types,str = '',j = '、'){
		str = str+'';

		var arr = [];
		str.split(',').forEach((val) => {
			if(val && types[val] != undefined){
				arr.push(types[val].goods_type_name)
			}
		})

		return arr.join(j)
	},

	// 平台格式化
	get_p(str = '',j = '、'){
		str = str+'';

		var arr = [];
		str.split(',').forEach((val) => {
			if(val == 1){
				arr.push('安卓');
			}else if(val == 2){
				arr.push('苹果');
			}else if(val == 3){
				arr.push('鸿蒙');
			}else if(val == 4){
				arr.push('微信小程序');
			}else if(val == 5){
				arr.push('微信公众号');
			}else if(val == 6){
				arr.push('支付宝小程序');
			}else if(val == 7){
				arr.push('抖音');
			}else{
				arr.push('快手');
			}

		})

		return arr.join(j)
	},

	// 平台格式化
	get_bsc(str = '',j = '、'){
		str = str+'';

		var arr = [];
		str.split(',').forEach((val) => {
			if(val == 1){
				arr.push('B端');
			}else if(val == 2){
				arr.push('S端');
			}else if(val == 3){
				arr.push('C端');
			}
		})

		return arr.join(j)
	},

	// 平台格式化
	get_is_type(str = '',j = '、'){
		str = str+'';

		var arr = [];
		str.split(',').forEach((val) => {
			if(val == 1){
				arr.push('常规');
			}else if(val == 2){
				arr.push('钜惠');
			}else if(val == 3){
				arr.push('秒杀');
			}else if(val == 4){
				arr.push('满赠');
			}else if(val == 5){
				arr.push('折扣');
			}else if(val == 6){
				arr.push('积分');
			}
		})

		return arr.join(j)
	},

	setCopyText(text) {
		const textarea = document.createElement('textarea');
		textarea.value = text;
		
		// 添加到文档中
		textarea.style.position = 'fixed';
		textarea.style.left = '0';
		textarea.style.top = '0';
		document.body.appendChild(textarea);
		
		// 选择文本
		textarea.select();
		
		try {
			const result = document.execCommand('copy');
			if (result) {
				util.alert('复制成功!');
			} else {
				util.alert('复制失败!','error');
			}
		} catch (error) {
				util.alert('复制错误!','error');
		}
		
		// 移除元素
		textarea.remove();
	},

	setOn(that,func = ''){
		that.pageKey = 'load_'+that.$route.path;
		// console.log('-------登录界面监听-------'+that.pageKey)
		store.state.load_path_no[that.pageKey] = 1;
		that.$eventBus.on(that.pageKey, (data) => {
			// console.log('-------调用-登录界面-------'+that.pageKey)
			func ? func(data) : '';
		});

	},
	
	setUrlOn(url,that,func = ''){
		that.pageKey = url;
		// console.log('-------登录界面监听-------'+that.pageKey)
		store.state.load_path_no[that.pageKey] = 1;
		that.$eventBus.on(that.pageKey, (data) => {
			// console.log('-------调用-登录界面-------'+that.pageKey)
			func ? func(data) : '';
		});

	},

	// 在新标签页打开链接，支持外部链接或内部路由路径/路由对象
	cliUrlHref(url, external = false) {
		if (!url) return;

		// 外部链接（包含协议或以 // 开头）或强制外部
		if (external || /^(https?:)?\/\//i.test(url)) {
			window.open(url, '_blank', 'noopener,noreferrer');
			return;
		}

		// 内部路由：使用 router.resolve 获取 href，然后在新标签打开
		try {
			let resolved = null;
			if (typeof url === 'string') {
				resolved = router.resolve({ path: url });
			} else {
				resolved = router.resolve(url);
			}
			const href = resolved && resolved.href ? resolved.href : String(resolved);
			const origin = window.location.origin || (window.location.protocol + '//' + window.location.host);
			window.open(origin + href, '_blank', 'noopener,noreferrer');
		} catch (e) {
			// 回退：直接打开原始字符串
			window.open(String(url), '_blank', 'noopener,noreferrer');
		}
	},

	delOn(that){
		delete store.state.load_path_no[that.pageKey];
		that.$eventBus.off(that.pageKey);
	},

	// 链接长连接
	sendPush(sendObj = {},exec = 0){
		sendSocket(sendObj,exec);
	},

	setSendSocket(is_load = false){
		console.log('------------登录长连接------------A')
		var send = store.state.send;
		console.log('login_socket_get',store.state.login_socket_get)

		if(store.state.login_socket_get == 1 || is_load){
			var port = store.state.port;
			console.log('发送')
			console.log('send',send)
			console.log('port',port)

			if(send){
				// 先清除原来的链接
				sendSocket({
					exe_way:'close'
				});

				store.state.login_socket_get = 0;

				if(send['port'] && send['port'][port]){
					sendSocket({
						send_uid:send['port'][port],
						exe_way:'login',
					})
				}

				if(send['group'] && send['group'][port]){
					sendSocket({
						group_id:send['group'][port],
						exe_way:'group',
					})
				}
			}

		}

		console.log('------------登录长连接------------B')
	},

}

export default util
